
// 流程节点类型
var WORKFLOW_NODE_TYPE = {
  Initiate: 'initiate',
  Approve: 'approve',
  AddApprove: 'add_approve',
  CC: 'cc',
  ConditionRoute: 'condition_route',
  Condition: 'condition',
  RobotFileProc: 'robot_file_proc',
  FileProc: 'file_proc',
}


// 流程类型-15版
var FLOW_TYPE = {
  file_dec: {
    type: 'file_dec',
    name: '文件解密申请',
    icon: ''
  },
  trust_mail: {
    type: 'trust_mail',
    name: '信任邮箱申请',
    icon: ''
  },
  file_cl: {
    type: 'file_cl',
    name: '文件转密级申请',
    icon: ''
  },
  file_auth: {
    type: 'file_auth',
    name: '文件授权申请',
    icon: ''
  },
  file_out: {
    type: 'file_out',
    name: '文件外发申请',
    icon: ''
  },
  gw_mail: {
    type: 'gw_mail',
    name: '邮件外发申请',
    icon: ''
  },
  file_clearwm: {
    type: 'file_clearwm',
    name: '文件清除水印申请',
    icon: ''
  },
  file_cli: {
    type: 'file_cli',
    name: '文件标密申请',
    icon: ''
  },
}

// 流程类型-16版
var FLOW_TYPE16 = {
  file_dec: {
    type: 'file_dec',
    name: '文件解密申请',
    icon: ''
  },
  trust_mail: {
    type: 'trust_mail',
    name: '信任邮箱申请',
    icon: ''
  },
  file_cl: {
    type: 'file_cl',
    name: '文件转密级申请',
    icon: ''
  },
  file_transp: {
    type: 'file_transp',
    name: '文件转透明申请',
    icon: ''
  },
  file_auth: {
    type: 'file_auth',
    name: '文件授权申请',
    icon: ''
  },
  file_out: {
    type: 'file_out',
    name: '文件外发申请',
    icon: ''
  },
  file_clearwm: {
    type: 'file_clearwm',
    name: '文件清除水印申请',
    icon: ''
  },
  file_cli: {
    type: 'file_cli',
    name: '文件标密申请',
    icon: ''
  },
}

// 流程状态-15版
var FLOW_STATE = {
  all: {
    state: '',
    name: '全部',
    icon: '',
    color: ''
  },
  awaiting_approval: {
    state: 'awaiting_approval',
    name: '审批中',
    icon: 'assignment',
    color: 'green'
  },
  approved: {
    state: 'approved',
    name: '审批已通过',
    icon: 'assignment',
    color: 'green'
  },
  rejected: {
    state: 'rejected',
    name: '审批已拒绝',
    icon: 'assignment',
    color: 'red'
  },
  finished: {
    state: 'finished',
    name: '已完成',
    icon: 'assignment',
    color: 'gray'
  },
  canceled: {
    state: 'canceled',
    name: '已取消',
    icon: 'assignment',
    color: 'gray'
  },
}

// 流程状态-16版
var FLOW_STATE16 = {
  all: {
    state: '',
    name: '全部',
    icon: '',
    color: ''
  },
  new: {
    state: 'new',
    name: '新建',
    icon: 'assignment',
    color: 'gray'
  },
  awaiting_approval: {
    state: 'awaiting_approval',
    name: '审批中',
    icon: 'assignment',
    color: 'green'
  },
  approved: {
    state: 'approved',
    name: '审批已通过',
    icon: 'assignment',
    color: 'green'
  },
  rejected: {
    state: 'rejected',
    name: '审批已拒绝',
    icon: 'assignment',
    color: 'red'
  },
  processing: {
    state: 'processing',
    name: '处理中',
    icon: 'assignment',
    color: 'gray'
  },
  processed: {
    state: 'processed',
    name: '已处理',
    icon: 'assignment',
    color: 'green'
  },
  finished: {
    state: 'finished',
    name: '已完成',
    icon: 'assignment',
    color: 'gray'
  },
  canceled: {
    state: 'canceled',
    name: '已取消',
    icon: 'assignment',
    color: 'gray'
  },
  terminated: {
    state: 'terminated',
    name: '已终止',
    icon: 'assignment',
    color: 'gray'
  },
}

// 任务类型-15版
var TASK_TYPE = {
  approval: {
    type: 'approval',
    name: '审批',
    icon: 'assignment',
    color: 'green',
  },
  download: {
    type: 'download',
    name: '下载解密',
    icon: 'assignment',
    color: 'green',
  },
  mail: {
    type: 'mail',
    name: '发送邮件',
    icon: 'assignment',
    color: 'green',
  },
}

// 任务类型-16版
var TASK_TYPE16 = {
  initiate: {
    type: 'initiate',
    name: '发起',
    icon: 'assignment',
    color: '',
  },
  approve: {
    type: 'approve',
    name: '审批',
    icon: 'assignment',
    color: 'green',
  },
  add_approve: {
    type: 'add_approve',
    name: '加签审批',
    icon: 'assignment',
    color: 'green',
  },
  cc: {
    type: 'cc',
    name: '抄送',
    icon: 'assignment',
    color: 'green',
  },
  robot_file_proc: {
    type: 'robot_file_proc',
    name: '文件处理',
    icon: 'assignment',
    color: 'green',
  },
  file_proc: {
    type: 'file_proc',
    name: '文件处理',
    icon: 'assignment',
    color: 'green',
  },
}


//  任务状态-15版
var TASK_STATE = {
  all: {
    state: '',
    name: '全部',
    icon: '',
    color: ''
  },
  approved: {
    state: 'approved',
    name: '已同意',
    icon: 'assignment',
    color: 'gray'
  },
  rejected: {
    state: 'rejected',
    name: '已拒绝',
    icon: 'assignment',
    color: 'gray'
  },
  awaiting: {
    state: 'awaiting',
    name: '未处理',
    icon: 'assignment',
    color: 'green'
  },
  terminated: {
    state: 'terminated',
    name: '已终止',
    icon: 'assignment',
    color: 'gray'
  },
}

//  任务状态-16版
var TASK_STATE16 = {
  all: {
    state: '',
    name: '全部',
    icon: '',
    color: ''
  },
  approved: {
    state: 'approved',
    name: '已同意',
    icon: 'assignment',
    color: 'gray'
  },
  rejected: {
    state: 'rejected',
    name: '已拒绝',
    icon: 'assignment',
    color: 'gray'
  },
  awaiting: {
    state: 'awaiting',
    name: '未处理',
    icon: 'assignment',
    color: 'green'
  },
  terminated: {
    state: 'terminated',
    name: '已终止',
    icon: 'assignment',
    color: 'gray'
  },
}

var WORKFLOW_TAST_State16 = {
  Awaiting: 'awaiting',// 未处理
  Approved: 'approved',// 已同意
  FinishApproved: 'finishApproved',// 已直接同意
  Rejected: 'rejected',// 已拒绝 
  Reviewed: 'reviewed',// 已审阅 
  Processed: 'processed',// 已处理
  Canceled: 'canceled', // 已取消
  Terminated: 'terminated',// 已终止
}



export {
  WORKFLOW_NODE_TYPE,
  FLOW_TYPE,
  FLOW_TYPE16,
  FLOW_STATE,
  FLOW_STATE16,
  TASK_TYPE,
  TASK_TYPE16,
  TASK_STATE,
  TASK_STATE16,
  WORKFLOW_TAST_State16
}